import { GetIncidentByIdResponse } from '@EHSNavigator/backend';
import { useApiClients } from '../../client/api/useApiClient';
import ReportedIncidents from '../../views/ReportedIncidents';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import Loader from '../../components/Loader';
import ErrorScreen from '../../components/ErrorScreen';

export default function ReportedIncidentsPage() {
  const { IncidentReportingApi } = useApiClients();
  const params = useParams();
  const id = params['my-reported-incidents'] || '';

  const { data, isLoading, error } = useQuery<
    GetIncidentByIdResponse['incident']
  >({
    queryKey: ['reported-incident-by-id', id],
    queryFn: async () => {
      const response =
        await IncidentReportingApi.incidentReportingControllerFindIncidentById({
          id,
        });
      return response?.data?.incident;
    },
  });

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <ErrorScreen />;
  }

  return (
    <div className="flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <ReportedIncidents data={data} />
    </div>
  );
}
